import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import TopNav from '../components/TopNav';
import Footer from '../components/Footer';
import { resolvePageContext } from '../utils/pageContext';

export default function Layout({ children }) {
  const location = useLocation();
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    const context = resolvePageContext(location.pathname);
    document.title = context.title === 'Home' ? 'Keyan Fayaz' : `${context.title} | Keyan Fayaz`;
    const changedPage = previousPath.current !== location.pathname;
    previousPath.current = location.pathname;
    const frame = window.requestAnimationFrame(() => {
      const target = location.hash && document.getElementById(location.hash.slice(1));
      if (target) {
        target.scrollIntoView();
        target.focus({ preventScroll: true });
      } else {
        window.scrollTo(0, 0);
        if (changedPage) document.getElementById('main-content')?.focus({ preventScroll: true });
      }
    });
    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname, location.hash]);

  return (
    <div className="personal-site">
      <TopNav />
      <main id="main-content" tabIndex={-1}>{children}</main>
      <Footer />
    </div>
  );
}
